import React from "react";
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import logo32x37 from "../../static/images/logo32x37.png";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";

class PrivateTopBarView extends React.Component {


    static propTypes = {
        dropDownText: PropTypes.string.isRequired
    };

    handleBrandClick = () => {
        EventPublisher.publish(UIInteractionEvents.PRIVATE_NAV_BRAND_CLICKED, {});
    };

    handleSearchAdSpacesClick = () => {
        EventPublisher.publish(UIInteractionEvents.PRIVATE_NAV_SEARCH_SPACES_CLICKED, {})
    };

    handleLogoutClick = () => {
        EventPublisher.publish(UIInteractionEvents.LOGOUT_BUTTON_CLICKED, {});
    };

    handleMySpacesClick = () => {
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_BUTTON_CLICK, {});
    };

    handleSpaceBalancesClick = () => {
        EventPublisher.publish(UIInteractionEvents.SPACE_BALANCE_BUTTON_CLICK, {});
    };

    handleMyAdvertisementClick = () => {
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_BUTTON_CLICK, {});
    };

    handleSpaceReservationClick = () => {
        EventPublisher.publish(UIInteractionEvents.SPACE_RESERVATION_BUTTON_CLICKED, {});
    };

    handleAdvertisementReservationClick = () => {
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_RESERVATION_BUTTON_CLICKED, {});
    };

    handleAdvertisementBillingClick = () => {
        EventPublisher.publish(UIInteractionEvents.ADVERTISING_BILLING_BUTTON_CLICK, {});
    };

    handleEditProfileClick = () => {
        EventPublisher.publish(UIInteractionEvents.EDIT_PROFILE_BUTTON_CLICKED, {});
    };

    render() {
        return(
            <nav className="navbar fixed-top navbar-expand-md navbar-light bg-light border-bottom-box">
                <button type="button" onClick={this.handleBrandClick} className="btn btn-link navbar-brand">
                    <img src={logo32x37} className="rounded mr-2" alt="Cuvered Logo"/>
                    <span className="brand-text">Cuvered</span>
                </button>

                <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarCollapseContent" aria-controls="navbarCollapseContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarCollapseContent">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item mr-1">
                            <button className="btn btn-outline-cuvered-pink" type="button" onClick={this.handleSearchAdSpacesClick}>
                                Search Ad Spaces
                            </button>
                        </li>
                        <li className="nav-item dropdown">
                            <button className="btn btn-outline-cuvered-purple dropdown-toggle" type="button" id="menuDropdown"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="fas fa-bars mr-1"/>
                                {this.props.dropDownText}
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="menuDropdown">
                                <h6 className="dropdown-header bg-cuvered-purple">
                                    <span className="text-light">
                                        <i className="fas fa-comment-dollar mr-1"/>
                                        Selling
                                    </span>
                                </h6>
                                <div className="dropdown-divider mt-0"/>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-purple" onClick={this.handleMySpacesClick}>
                                    <i className="fas fa-home mr-1"/>
                                    My Spaces
                                </button>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-purple" onClick={this.handleSpaceReservationClick}>
                                    <i className="fas fa-calendar-alt mr-1"/>
                                    Space Reservations
                                </button>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-purple" onClick={this.handleSpaceBalancesClick}>
                                    <i className="fas fa-balance-scale mr-1"/>
                                    Balances
                                </button>
                                <h6 className="dropdown-header bg-cuvered-blue mt-2">
                                    <span className="text-light">
                                        <i className="fas fa-credit-card mr-1"/>
                                        Buying
                                    </span>
                                </h6>
                                <div className="dropdown-divider mt-0"/>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-blue" onClick={this.handleMyAdvertisementClick}>
                                    <i className="fas fa-ad mr-1"/>
                                    My Advertisements
                                </button>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-blue" onClick={this.handleAdvertisementReservationClick}>
                                    <i className="fas fa-calendar-week mr-1"/>
                                    Advertisement Reservations
                                </button>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-blue" onClick={this.handleAdvertisementBillingClick}>
                                    <i className="fas fa-file-invoice-dollar mr-1"/>
                                    Billing
                                </button>
                                <h6 className="dropdown-header bg-cuvered-light-blue mt-2">
                                    <span className="text-light">
                                        <i className="fas fa-user-cog mr-1 "/>
                                        Account and Profile
                                    </span>
                                </h6>
                                <div className="dropdown-divider mt-0"/>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-light-blue"  onClick={this.handleEditProfileClick}>
                                    <i className="fas fa-user-cog mr-1"/>
                                    Edit Profile
                                </button>
                                <button type="button" className="dropdown-item btn btn-link text-cuvered-light-blue" onClick={this.handleLogoutClick}>
                                    <i className="fas fa-sign-out-alt mr-1"/>
                                    Logout
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}

export default PrivateTopBarView;